module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/btn-share.689fd206.png";